const gltfBase = '/build/3d-models';
const gltf30 = `${gltfBase}/g30/g30.gltf`;
const gltf50 = `${gltfBase}/g50/g60.gltf`;
const gltf15 = `${gltfBase}/g15/G15.gltf`;
const gltfFlute = `${gltfBase}/champagne/champagne.gltf`;
const gltfVin = `${gltfBase}/wine/wine.gltf`;
import shapeG15 from '../../../../images/configurator/static/shapes/g15.svg';
import shapeG25 from '../../../../images/configurator/static/shapes/g25.svg';
import shapeG50 from '../../../../images/configurator/static/shapes/g50.svg';
import shapeWine from '../../../../images/configurator/static/shapes/wine.svg';
import shapeChampagne from '../../../../images/configurator/static/shapes/champagne.svg';

// TODO Update IDs with production data
export const SizeId = Object.freeze({
  G25: 11,
  G50: 12,
  G15: 10,
  WINE: 13,
  CHAMPAGNE: 14,
});

export const DEFAULT_SIZE_ID = SizeId.G25;

/**
 * @enum
 * @readonly
 */
export const CameraPosition = Object.freeze({
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  BACK: 'back',
});

export default {
  // 25cl
  [SizeId.G25]: {
    diameter: 190 / Math.PI,
    height: 114,
    gltfUrl: gltf30,
    icon: 'g25',
    shadowPositionY: '90%',
    cameraPosition: {
      [CameraPosition.LEFT]: [-3.35, 0.71, 0],
      [CameraPosition.CENTER]: [0, 3.5, 0],
      [CameraPosition.RIGHT]: [3.35, 0.71, 0],
      [CameraPosition.BACK]: [0, 0.71, -3.5],
    },
    shapeUrl: shapeG25,
  },
  // 50cl
  [SizeId.G50]: {
    diameter: 250 / Math.PI,
    height: 150,
    gltfUrl: gltf50,
    icon: 'g50',
    shadowPositionY: '105%',
    cameraPosition: {
      [CameraPosition.LEFT]: [4.4, 0.92, 0],
      [CameraPosition.CENTER]: [0, 4.5, 0],
      // [CameraPosition.CENTER]: [0, 0.92, -4.39],
      [CameraPosition.RIGHT]: [-4.4, 0.92, 0],
      [CameraPosition.BACK]: [0, 0.92, -4.5],
    },
    shapeUrl: shapeG50,
  },
  // 15cl
  [SizeId.G15]: {
    diameter: 65,
    height: 89,
    gltfUrl: gltf15,
    icon: 'g15',
    shadowPositionY: '100%',
    cameraPosition: {
      [CameraPosition.LEFT]: [-2.24, 0.57, 1.58],
      [CameraPosition.CENTER]: [0, 2.8, 0],
      [CameraPosition.RIGHT]: [2.55, 0.57, 1],
      [CameraPosition.BACK]: [0, 0.57, -2.8],
    },
    shapeUrl: shapeG15,
  },
  // vin
  [SizeId.WINE]: {
    diameter: 185 / Math.PI,
    height: 140,
    gltfUrl: gltfVin,
    icon: 'wineglass',
    shadowPositionY: '110%',
    cameraPosition: {
      [CameraPosition.LEFT]: [-3.81, 0.81, 0.89],
      [CameraPosition.CENTER]: [0, 4, 0],
      [CameraPosition.RIGHT]: [3.81, 0.81, 0.89],
      [CameraPosition.BACK]: [0, 0.81, -4],
    },
    shapeUrl: shapeWine,
  },
  // flûte
  [SizeId.CHAMPAGNE]: {
    diameter: 170 / Math.PI,
    height: 180,
    gltfUrl: gltfFlute,
    icon: 'flute',
    shadowPositionY: '125%',
    cameraPosition: {
      [CameraPosition.LEFT]: [-4.89, 1.02, -0.17],
      [CameraPosition.CENTER]: [0, 5, 0],
      [CameraPosition.RIGHT]: [4.89, 1.02, -0.17],
      [CameraPosition.BACK]: [0, 1.02, -5],
    },
    shapeUrl: shapeChampagne,
  },
};
